var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-header-wrapper-bg"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"left"},[_vm._t("left")],2),_c('div',{staticClass:"right"},[_c('customInput',{on:{"handleSearch":_vm.handleSearch},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }